module.exports = __webpack_public_path__ + "assets/img/fb2adfa4a2578da0d9af21b28bd5d5f6.svg";